import { AccountantService, LocalStorageService } from "../../services";
import { Button, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { EnhancedButtonPrimeReactSeverity, useNavigateToLogout } from "../../common/Common";
import {
	EnhancedDropDownRHFWithLabel,
	EnhancedSnackbar,
	IEnhancedDropDownItem,
	RHookFormTextFieldWithLabel,
	Spacer,
	SubmitButton,
	SubmitButtonVariant,
} from "@websential/cosmic-v20";
import { FormProvider, useForm } from "react-hook-form";
import {
	IGetListRequest,
	ISignInResponse,
	IVerifyOtpByMessege,
} from "../../models";
import {
	setSelectedAccountant,
	setSelectedAccountantName,
	setSelectedClient,
	signInSuccess,
} from "../../store/actions";

import { AccountFormLayout } from "../AccountFormLayout";
import { AuthService } from "../../services/AuthService";
import { EnhancedButtonPrimeReact } from "../../../src/components/EnhancedButtonPrimeReact/index";
import { INITIAL_SNACKBAR_DATA } from "../../common/constants";
import { useDispatch } from "react-redux";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";

const durationOptions = [
	{ label: "30 days", value: 43200 }, // 30 * 24 * 60
	{ label: "60 days", value: 86400 }, // 60 * 24 * 60
	{ label: "90 days", value: 129600 }, // 90 * 24 * 60
];

type FormValues = {
	otp: string;
	expiresInMinutes: number;
};

const OtpFormComponent = () => {
	// RESPONSIVE
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const formMethods = useForm<FormValues>({
		mode: "onBlur",
		reValidateMode: "onChange",
	});
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [expireAfterSelectedValue, setExpireAfterSelectedValue] =
		useState<any>(undefined);

	const navigateToLogout = useNavigateToLogout();
	const [accountantQueryParams, setaccountantQueryParams] =
		useState<IGetListRequest>({
			search_query: "",
			order_by: "acc_title",
			order_direction: "asc",
			page: 1,
			size: 25,
		});

	const [clientQueryParams, setclientQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "client_name",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const dispatch = useDispatch();

	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") return;
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	// const { isPending, mutate } = useMutation({
	// 	mutationFn: AuthService.verifyOtpByMessege,
	// 	onSuccess: (res: any) => {
	// 		if (res.status && res.user && res.user.twoFactorAuth) {
	// 			localStorage.setItem("accessToken", res.user.accessToken);
	// 			LocalStorageService.setUser(res);
	// 			setSnackbarData({
	// 				open: true,
	// 				message: res.message,
	// 				severity: "success",
	// 			});
	// 			dispatch(signInSuccess(res));
	// 			if (res.user.isSuperStatus !== 400) {
	// 				(async () => {
	// 					try {
	// 						const accountantResponse: any =
	// 							await AccountantService.getAccountants(accountantQueryParams, res.user.isSuperStatus);
	// 						if (accountantResponse && accountantResponse.items.length === 1) {
	// 							dispatch(setSelectedAccountant(accountantResponse.items[0]));
	// 							dispatch(setSelectedAccountantName(accountantResponse.items[0]));
	// 							try {
	// 								const clientResponse: any =
	// 									await AccountantService.getClientByAccountantId(
	// 										accountantResponse.items[0].id,
	// 										res.user.isSuperStatus,
	// 										clientQueryParams,
	// 										navigateToLogout
	// 									);
	// 								if (clientResponse && clientResponse.items.length === 1) {
	// 									dispatch(setSelectedClient(clientResponse.items[0]));
	// 								}
	// 							} catch { }
	// 						} else if (
	// 							accountantResponse &&
	// 							accountantResponse.items.length === 0
	// 						) {
	// 							try {
	// 								const clientResponse: any =
	// 									await AccountantService.getClientByAccountantId(
	// 										"",
	// 										res.user.isSuperStatus,
	// 										clientQueryParams,
	// 										navigateToLogout
	// 									);
	// 								if (clientResponse && clientResponse.items.length === 1) {
	// 									dispatch(setSelectedClient(clientResponse.items[0]));
	// 								}
	// 							} catch { }
	// 						}
	// 					} catch { }
	// 				})();
	// 			}
	// 		} else {
	// 			setSnackbarData({
	// 				open: true,
	// 				message: res.message,
	// 				severity: res.status ? "success" : "error",
	// 			});
	// 		}
	// 	},
	// 	onError: () => {
	// 		setSnackbarData({
	// 			open: true,
	// 			message: "Something went wrong, try again later!",
	// 			severity: "error",
	// 		});
	// 	},
	// });

	const { isPending, mutate } = useMutation({
		mutationFn: AuthService.verifyOtpByMessege,

		onSuccess: async (res: any) => {
			try {
				if (!(res.status && res.user && res.user.twoFactorAuth)) {
					setSnackbarData({
						open: true,
						message: res.message,
						severity: res.status ? "success" : "error",
					});
					return;
				}

				localStorage.setItem("accessToken", res.user.accessToken);
				LocalStorageService.setUser(res);

				dispatch(signInSuccess(res));

				setSnackbarData({
					open: true,
					message: res.message,
					severity: "success",
				});

				if (res.user.isSuperStatus !== 400) {
					const accountantResponse: any =
						await AccountantService.getAccountants(
							accountantQueryParams,
							res.user.isSuperStatus
						);

					if (accountantResponse?.items?.length === 1) {
						dispatch(setSelectedAccountant(accountantResponse.items[0]));
						dispatch(setSelectedAccountantName(accountantResponse.items[0]));

						const clientResponse: any =
							await AccountantService.getClientByAccountantId(
								accountantResponse.items[0].id,
								res.user.isSuperStatus,
								clientQueryParams,
								navigateToLogout
							);

						if (clientResponse?.items?.length === 1) {
							dispatch(setSelectedClient(clientResponse.items[0]));
						}
					} else if (accountantResponse?.items?.length === 0) {
						const clientResponse: any =
							await AccountantService.getClientByAccountantId(
								"",
								res.user.isSuperStatus,
								clientQueryParams,
								navigateToLogout
							);

						if (clientResponse?.items?.length === 1) {
							dispatch(setSelectedClient(clientResponse.items[0]));
						}
					}
				}

				// Everything has completed
				window.location.replace(
					window.location.origin +
					window.location.pathname +
					"#/"
				);
			} catch (error) {
				console.error(error);

				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
		},
	});

	const handleCodeRequest = (type: "sms" | "call") => {
		const accessToken = localStorage.getItem("accessToken") || "";

		if (!accessToken) {
			setSnackbarData({
				open: true,
				message: "Missing access token. Please login again.",
				severity: "error",
			});
			return;
		}

		const api =
			type === "sms"
				? () => AuthService.CreateOtpByMessege(accessToken)
				: () => AuthService.CreateOtpByMessege(accessToken);

		api()
			.then((res: any) => {

				if (res.status && res.accessToken) {
					localStorage.setItem("accessToken", res.accessToken);
				}

				setSnackbarData({
					open: true,
					message: res.message,
					severity: res.status ? "success" : "error",
				});
			})
			.catch(() => {
				setSnackbarData({
					open: true,
					message: "Failed to send code. Try again later!",
					severity: "error",
				});
			});
	};

	const onSubmit = (formValues: FormValues) => {
		const accessToken = localStorage.getItem("accessToken") || "";
		const expiresAfter = formValues.expiresInMinutes
			? new Date(Date.now() + formValues.expiresInMinutes * 60000)
				.toISOString()
				.split("T")[0]
			: undefined;

		const payload: IVerifyOtpByMessege = {
			accessToken,
			otp: formValues.otp,
			expiresAfter,
		};

		mutate(payload);
	};

	return (
		<>
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<Grid container spacing={2}>
						<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
							<RHookFormTextFieldWithLabel
								label="Enter code sent on your phone"
								id="otp"
								testId="otp-field"
								placeholder="Enter OTP code"
							/>
						</Grid>

						<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
							<EnhancedDropDownRHFWithLabel
								label="Disable codes to this device for"
								testId="otp-expiry-field"
								selectName="expiresInMinutes"
								items={durationOptions}
								onSelectionChangeHandler={(val) =>
									setExpireAfterSelectedValue(val.value)
								}
								selectedItem={expireAfterSelectedValue}
							/>
						</Grid>
						<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>

							<EnhancedButtonPrimeReact
								label="Verify Code"
								type="submit"
								raised
								style={{ marginLeft: "0rem" }}
								severity={EnhancedButtonPrimeReactSeverity.Success}
								loading={isPending}
							/>
						</Grid>
						<Spacer y={1} />

						<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
							<Typography variant="body2" color="textSecondary">
								Not recieved the code ? Choose an option to resend
							</Typography>
						</Grid>

						<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} >
							<Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
								<EnhancedButtonPrimeReact
									label="Get Code via SMS"
									raised
									style={{ width: "-webkit-fill-available", }}
									onClickHandler={() => handleCodeRequest("sms")}
									severity={EnhancedButtonPrimeReactSeverity.Secondary}
								/>
							</Grid>
							<Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
								<EnhancedButtonPrimeReact
									label="Get Code via Call"
									raised
									style={{ width: "-webkit-fill-available" }}
									onClickHandler={() => handleCodeRequest("call")}
									severity={EnhancedButtonPrimeReactSeverity.Secondary}
								/>
							</Grid>
						</Grid>
					</Grid>
				</form>
			</FormProvider>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId="otp-form-snackbar"
				open={snackbarData.open}
				autoHide={true}
			/>
		</>
	);
};

export const OtpForm = () => {
	return (
		<AccountFormLayout
			title="Verify Cell No."
			subtitle="Having trouble with this method?"
			subtitleLinkText="Select another method."
			subtitleLinkNavigateTo="/auth-selection-screen-for-login"
			form={<OtpFormComponent />}
		/>
	);
};
